import React, {useCallback, useEffect} from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './Schedules.metadata.json5';


function Schedules(props) {

    const {
        coverage,
        onScheduleChange,
        covIndex,
        onValidate
    } = props

    const generateScheduleOverrides = () => {
        const overrides = coverage.schedules.children.map((item, index) => {
            return {
                [`scheduleItemId${index}`]: {
                    onValidate: onValidate,
                    onScheduleChange: (schedule, path) => { 
                        const _path = `lobData.homeowners.offerings.children[0].coverages.dwellingCoverages.children.${covIndex}.${path}`
                        return onScheduleChange(schedule, _path, index)
                    }
                }            
            };
        });
        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        ...generateScheduleOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveComponentMap: {
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={coverage}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default Schedules;